import { useIntl } from "react-intl";
import { InteractionListAccordionItemProps } from "./types";
import { useStyle } from "./style";
import {
	NoInteractionPlaceholder,
	PlaceholderType,
} from "@/components/atoms/NoInteractionPlaceholder";
import {
	AccordionItem,
	mergeClasses,
	AccordionHeader,
	AccordionPanel,
	Text,
} from "@fluentui/react-components";
import { List } from "@/components/atoms/list";
import { InteractionState } from "@/components/organisms/interaction/types";
import { ForwardedRef, forwardRef, useMemo } from "react";

export const InteractionListAccordionItem = forwardRef(
	(
		props: InteractionListAccordionItemProps,
		ref: ForwardedRef<HTMLDivElement>
	) => {
		const intl = useIntl();
		const classes = useStyle();

		const {
			value,
			items,
			unfilteredNumberOfItems,
			listClassNames,
			selectedId,
			getEndMedia,
		} = props;

		const titlePrefixKey = useMemo(() => {
			switch (value) {
				case InteractionState.Active:
					return "InteractionPanel.Active";
				case InteractionState.Waiting:
					return "InteractionPanel.Waiting";
				case InteractionState.Voicemail:
					return "InteractionPanel.Voicemails";
				default:
					return "";
			}
		}, [value]);

		const placeholderType = useMemo(() => {
			switch (value) {
				case InteractionState.Active:
					return PlaceholderType.Active;
				case InteractionState.Voicemail:
					return PlaceholderType.Voicemail;
				case InteractionState.Waiting:
				default:
					return PlaceholderType.Waiting;
			}
		}, [value]);

		return (
			<AccordionItem
				key={value}
				value={value}
				className={mergeClasses(classes.accordionContainer)}
				ref={ref}
			>
				<AccordionHeader
					size="small"
					className={mergeClasses(
						classes.accordionHeader,
						classes.accordionContainer
					)}
				>
					{intl.formatMessage({ id: titlePrefixKey })}
					<Text className={mergeClasses(classes.accordionCount)}>
						(
						{!unfilteredNumberOfItems ||
						items?.length === unfilteredNumberOfItems
							? items?.length ?? 0
							: `${items?.length ?? 0} ${intl.formatMessage({ id: "InteractionPanel.Of" })} ${unfilteredNumberOfItems} ${intl.formatMessage({ id: "InteractionPanel.Visible" })}`}
						)
					</Text>
				</AccordionHeader>
				<AccordionPanel className={mergeClasses(classes.accordionPanel)}>
					{items.length > 0 ? (
						<List
							items={items}
							classesName={listClassNames}
							selectedId={selectedId}
							getEndMedia={getEndMedia}
						/>
					) : (
						<NoInteractionPlaceholder type={placeholderType} />
					)}
				</AccordionPanel>
			</AccordionItem>
		);
	}
);
